import React, { useState } from 'react';
import './ImageSlider.css';

interface ImageSliderProps {
  images?: string[];
  title: string;
}

const ImageSlider: React.FC<ImageSliderProps> = ({ images, title }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  if (!images || images.length === 0) {
    return (
      <div className="product-image no-image">
        <div className="placeholder">No Image</div>
      </div>
    );
  }

  if (images.length === 1) {
    return (
      <div className="product-image">
        <img src={images[0]} alt={title} />
      </div>
    );
  }

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <div className="product-image">
      <div className="slider-container">
        <img
          src={images[currentIndex]}
          alt={`${title} - ${currentIndex + 1} di ${images.length}`}
        />
        {images.length > 1 && (
          <>
            <button
              className="slider-button prev"
              onClick={handlePrevious}
              aria-label="Immagine precedente"
            >
              ‹
            </button>
            <button
              className="slider-button next"
              onClick={handleNext}
              aria-label="Immagine successiva"
            >
              ›
            </button>
          </>
        )}
      </div>

      {images.length > 1 && (
        <div className="slider-indicators">
          {images.map((_, index) => (
            <button
              key={index}
              className={`indicator ${index === currentIndex ? 'active' : ''}`}
              onClick={() => setCurrentIndex(index)}
              aria-label={`Vai all'immagine ${index + 1}`}
            />
          ))}
          <span className="slider-counter">
            {currentIndex + 1} / {images.length}
          </span>
        </div>
      )}
    </div>
  );
};

export default ImageSlider;
